import { EmblaCarouselType } from 'embla-carousel'
import IntervalTimer from '../../utils/interval-timer'

interface CarouselAutoPlayType {
  play: () => void
  stop: () => void
  start: () => void
  pause: () => void
}

const carouselAutoPlay = (
  embla: EmblaCarouselType,
  interval: number,
): CarouselAutoPlayType => {
  const next = (): void => {
    const lastSlideIndex = embla.scrollSnapList().length - 1
    const isLastSlide = embla.selectedScrollSnap() === lastSlideIndex

    if (isLastSlide) {
      embla.scrollTo(0)
    } else {
      embla.scrollNext()
    }
  }

  const intervalTimer = new IntervalTimer(next, interval)

  const play = (): void => {
    intervalTimer.resume()
  }

  const stop = (): void => {
    intervalTimer.stop()
  }

  const pause = (): void => {
    intervalTimer.pause()
  }

  const start = (): void => {
    intervalTimer.start()
  }

  return { play, stop, start, pause }
}

export default carouselAutoPlay
